module.exports = __webpack_public_path__ + "static/media/stairsSound.1269559f.mp3";